import { BaseService } from './BaseService';
import fetchOperatorsQuery from '@/graphql/queries/FetchOperators.gql';
import assignShipmentQuery from '@/graphql/mutations/ShipmentAssign.gql';
import unAssignShipmentQuery from '@/graphql/mutations/UnassignShipment.gql';
import { ApolloQueryResult } from 'apollo-client';
import { FetchResult } from 'apollo-link';
import { searchOperators, assignShipment, unassignShipment } from '@/types/graphql/schemaTypes';

class OperatorService extends BaseService {
  public fetchOperators(): Promise<ApolloQueryResult<searchOperators>> {
    return this.client.query({
      query: fetchOperatorsQuery,
      variables: {},
      fetchPolicy: 'cache-first'
    });
  }

  public assignShipment(shipmentId: string, operatorId?: string):
    Promise<FetchResult<assignShipment>> {
    return this.client.mutate({
      mutation: assignShipmentQuery,
      variables: {
        arguments: {
          operatorId,
          shipmentId
        }
      }
    });
  }

  public unassignShipment(shipmentId: string):
    Promise<FetchResult<unassignShipment>> {
    return this.client.mutate({
      mutation: unAssignShipmentQuery,
      variables: {
        arguments: {
          shipmentId
        }
      }
    });
  }
}

export const operatorService = new OperatorService();
